export default {
  NOTIFICATIONS_SELECT: '@NOTIFICATIONS_SELECT',
  NOTIFICATIONS_APPLY_FILTER: '@NOTIFICATIONS_APPLY_FILTER',
  NOTIFICATIONS_UNSELECT_ALL: '@NOTIFICATIONS_UNSELECT_ALL',

  NOTIFICATIONS_GET_ITEMS_LOADING: '@NOTIFICATIONS_GET_ITEMS_LOADING',
  NOTIFICATIONS_GET_ITEMS_SUCCESS: '@NOTIFICATIONS_GET_ITEMS_SUCCESS',
  NOTIFICATIONS_GET_ITEMS_ERROR: '@NOTIFICATIONS_GET_ITEMS_ERROR',

  NOTIFICATIONS_GET_FILTERED_ITEMS_LOADING: '@NOTIFICATIONS_GET_FILTERED_ITEMS_LOADING',
  NOTIFICATIONS_GET_FILTERED_ITEMS_SUCCESS: '@NOTIFICATIONS_GET_FILTERED_ITEMS_SUCCESS',
  NOTIFICATIONS_GET_FILTERED_ITEMS_ERROR: '@NOTIFICATIONS_GET_FILTERED_ITEMS_ERROR',

  NOTIFICATIONS_UPDATE_ITEM_READ_SUCCESS: '@NOTIFICATIONS_UPDATE_ITEM_READ_SUCCESS',
  NOTIFICATIONS_UPDATE_ITEM_READ_ERROR: '@NOTIFICATIONS_UPDATE_ITEM_READ_ERROR',

  NOTIFICATIONS_CLEAR_ITEMS: '@NOTIFICATIONS_CLEAR_ITEMS',
};
